class ProductOETable {
    constructor($el) {
        this.$el = $el;
        this.$table = null;
        this.$overflow = null;
        this.$tableBody = null;

        this.scrollbar = null;
        this.tableInstance = null;

        if(this.$el.length) {
            this._createTable();
        }
    }

    _bindEvents() {
        this.resizeFn = this.resize.bind(this);

        $(window).on('resize', this.resizeFn);
    }

    _createTable() {
        this.tableInstance = this.$el.DataTable({
            scrollY: 417,
            scrollX: true,
            scrollCollapse: true,
            paging: false,
            searching: false,
            ordering: true,
            info: false,
            // responsive: true,
            autoWidth: false
            // initComplete: this._onTableReady.bind(this)
        });
        this._onTableReady();
    }

    _onTableReady() {
        this._findDOMElements();
        this._initTableScrollbar();
        this.resize();
        this._bindEvents();
    }

    _findDOMElements() {
        this.$overflow = this.$el.parents('.product-oe-number-table-overflow');
        this.$tableBody = this.$overflow.find('.dataTables_scrollBody');
    }

    _initTableScrollbar() {
        this.scrollbar = new SimpleBar(this.$tableBody[0]);
    }

    resize() {
        const wW = window.innerWidth;

        if(wW < 992) {
            this.$tableBody.css('max-height', 360);
        }
        else if(wW >= 992 && wW < 1200) {
            // this.$tableBody.css('max-height', 520);
            this.$tableBody.css('max-height', 455);
        }
        else if(wW >= 1200) {
            this.$tableBody.css('max-height', 320);
        }

        this.tableInstance.columns.adjust();
    }
}

export default ProductOETable;
